document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-id="element-110"]').forEach(wrapper => {

    const buttons = wrapper.querySelectorAll('button[data-variant-id]');
    const productForm = wrapper.closest("form"); // scope to product
    if (!productForm) return;

    const variantSelect = productForm.querySelector('select[name="id"]');
    if (!variantSelect) return;

    const options = variantSelect.querySelectorAll("option");

    function syncUI(variantId) {
      buttons.forEach(btn => {
        const active = btn.dataset.variantId === variantId;

        btn.classList.toggle("bg-white", active);
        btn.classList.toggle("text-teal-700", active);
        btn.classList.toggle("shadow-sm", active);
        btn.classList.toggle("text-stone-500", !active);
      });

      variantSelect.value = variantId;
      options.forEach(opt => {
        opt.toggleAttribute("selected", opt.value === variantId);
      });
    }

    buttons.forEach(btn => {
      btn.addEventListener("click", function () {
        const variantId = this.dataset.variantId;
        syncUI(variantId);
        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    variantSelect.addEventListener("change", function () {
      syncUI(this.value);
    });
    syncUI(variantSelect.value);
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".subscription-section");
  const target = document.getElementById("product-grid");

  if (!target || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function () {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("product-grid");
  const subscriptionBottom = document.getElementById("subscription-bottom");

  if (!productGrid || !subscriptionBottom) return;
  let lastScrollY = window.scrollY;
  function onScroll() {
    const rect = productGrid.getBoundingClientRect();
    const viewportCenter = window.innerHeight / 2;
    const elementCenter = rect.top + rect.height / 2;
    const tolerance = 50;
    const scrollingDown = window.scrollY > lastScrollY;
    const scrollingUp = window.scrollY < lastScrollY;

    if (
      scrollingDown &&
      elementCenter >= viewportCenter - tolerance &&
      elementCenter <= viewportCenter + tolerance
    ) {
      subscriptionBottom.classList.add("active");
    }

    if (
      scrollingUp &&
      elementCenter > viewportCenter + tolerance
    ) {
      subscriptionBottom.classList.remove("active");
    }

    lastScrollY = window.scrollY;
  }
  window.addEventListener("scroll", onScroll);
});



document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-id="element-95"]').forEach(card => {
    const buttons = card.querySelectorAll('[data-id="element-110"] button');
    const select = card.querySelector('select[name="id"]');
    const salePrice = card.querySelector('[data-sale-price]');
    const regularPrice = card.querySelector('[data-regular-price]');
    const savePercent = card.querySelector('[data-save-percent]'); // add this in HTML

    if (!select || !salePrice) return;

    const getDiscount = (text) => {
      if (text.includes('30 Days')) return 10;
      if (text.includes('60 Days')) return 15;
      if (text.includes('90 Days')) return 20;
      return 0;
    };

    const getBasePrice = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return 0;

      const priceAttr = option.getAttribute('data-price');
      if (!priceAttr) return 0;

      return parseFloat(priceAttr.replace(/[^\d]/g, ''));
    };

    const updateUI = (discount) => {
      const base = getBasePrice();
      if (!base) return;

      const finalPrice = Math.round(base * (1 - discount / 100));
      salePrice.textContent = `₹${finalPrice.toLocaleString('en-IN')}`;

      const option = select.options[select.selectedIndex];
      if (!option) return 0;
      const cpriceAttr = option.getAttribute('data-cprice');

      if (regularPrice) {
        regularPrice.textContent = `${cpriceAttr}`;
      }

      const cleanPrice = (price) => {
        return parseFloat(price.replace(/[^0-9.]/g, '')) || 0;
      };
      const cpriceAttrNum = cleanPrice(cpriceAttr);
      
      savedPercent = Math.round(((cpriceAttrNum - finalPrice) / cpriceAttrNum) * 100);

      if (savePercent) {
        savePercent.textContent = `Save ${savedPercent}%`;
      }
    };

    const activateButton = (active) => {
      buttons.forEach(btn => {
        btn.classList.remove('bg-white','text-teal-700','shadow-sm');
        btn.classList.add('text-stone-500');
      });

      if (active) {
        active.classList.add('bg-white','text-teal-700','shadow-sm');
        active.classList.remove('text-stone-500');
      }
    };

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        select.value = btn.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const discount = getDiscount(btn.textContent);
        activateButton(btn);
        updateUI(discount);
      });
    });

    select.addEventListener('change', () => {
      const selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) return;

      const discount = getDiscount(selectedOption.textContent);
      updateUI(discount);
      buttons.forEach(btn => {
        if (btn.dataset.variantId === select.value) {
          activateButton(btn);
        }
      });
    });

    const selectedOption = select.options[select.selectedIndex];
    if (selectedOption) {
      const discount = getDiscount(selectedOption.textContent);
      updateUI(discount);
      buttons.forEach(btn => {
        if (btn.dataset.variantId === selectedOption.value) {
          activateButton(btn);
        }
      });
    }

  });
});


document.addEventListener("click", function (e) {
  const mainBtn = e.target.closest('[data-id="element-151"]');
  if (!mainBtn) return;

  e.preventDefault();
  const form = mainBtn.closest('form');
  if (!form) return;

  const recurpayBtn = form.querySelector('[data-recurpay-action]');
  if (recurpayBtn) {
    recurpayBtn.click();
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll('[data-id="element-41"]');

  accordions.forEach((item, index) => {
    const button = item.querySelector("button");
    const content = item.querySelector('[data-id="element-48"]');
    const icon = button.querySelector("svg");

    // Close all by default
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease, opacity 0.3s ease";

    if (index === 0) {
      // 🔥 First item open
      content.style.height = content.scrollHeight + "px";
      content.style.opacity = "1";
      icon.classList.add("rotate-180");
      icon.innerHTML = `<path d="M5 12h14"></path>`;
    } else {
      content.style.height = "0px";
      content.style.opacity = "0";
      icon.innerHTML = `
        <path d="M5 12h14"></path>
        <path d="M12 5v14"></path>
      `;
    }

    button.addEventListener("click", () => {
      const isOpen = icon.classList.contains("rotate-180");

      // Close all
      accordions.forEach((el) => {
        const c = el.querySelector('[data-id="element-48"]');
        const i = el.querySelector("svg");

        c.style.height = "0px";
        c.style.opacity = "0";
        i.classList.remove("rotate-180");
        i.innerHTML = `
          <path d="M5 12h14"></path>
          <path d="M12 5v14"></path>
        `;
      });

      // Open clicked
      if (!isOpen) {
        content.style.height = content.scrollHeight + "px";
        content.style.opacity = "1";
        icon.classList.add("rotate-180");
        icon.innerHTML = `<path d="M5 12h14"></path>`;
      }
    });
  });
});